import React, { FunctionComponent } from 'react';
import ParentComponent, {
  TParentComponentProps,
} from '@views/components/common/ParentComponent';

export const TableMessage: FunctionComponent<TParentComponentProps> = (
  props
) => {
  return <ParentComponent {...props} />;
};

TableMessage.defaultProps = {
  defaultClassName: 'cart-table__message',
  as: 'div',
};

export default TableMessage;
